import { SxProps, Theme } from '@mui/material/styles';

export const modalStyles = {
	paper: (fullHeight: boolean): SxProps<Theme> => ({
		maxHeight: '90dvh',
		height: fullHeight ? '90dvh' : 'unset'
	}),

	title: {
		px: 2,
		py: 2,
		color: 'text.fadedPrimary',
		fontWeight: 700,
		zIndex: 1
	},

	titleRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: 1,
		width: '100%',
		fontSize: '1.25rem'
	},

	titleSlot: {
		flex: 1,
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	titleEnd: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 1,
		flexShrink: 0
	},

	header:
		(scrolled: boolean): SxProps<Theme> =>
		theme => ({
			px: 2,
			pb: 2,
			borderBottom: '1px solid var(--mui-palette-divider)',
			boxShadow: scrolled ? theme.customShadows.scrollDown : 'none',
			zIndex: 1,
			transition: 'box-shadow 0.2s ease'
		}),

	body: (hasFooter: boolean): SxProps<Theme> => ({
		px: 2,
		pt: 0,
		pb: hasFooter ? 0 : 2,
		overflowY: 'auto'
	}),

	footer:
		(atBottom: boolean, footerSpacing: boolean): SxProps<Theme> =>
		theme => ({
			px: 2,
			py: 2,
			mt: footerSpacing ? 2 : 0,
			borderTop: '1px solid var(--mui-palette-divider)',
			boxShadow: atBottom ? 'none' : theme.customShadows.scrollUp,
			zIndex: 1,
			transition: 'box-shadow 0.2s ease'
		})
};
